import React from 'react';
import T from 'utils/useLocalizer';

import FormLabel from '../label/FormLabel';

type SizeType = 'sm' | 'lg';

interface Props {
  id?: string;
  label?: string;
  labelDesc?: string;
  placeholder?: string;
  inputProps: any;
  isError?: boolean;
  errorMessage?: string;
  required?: boolean;
  disabled?: boolean;
  hidden?: boolean;
  readOnly?: boolean;
  autoFocus?: boolean;
  maxLength?: number;
  textLength?: number;
  customClassName?: string;
  customInputClassName?: string;
  hint?: string;
  hintId?: string;
  size?: SizeType;
  defaultValue?: string;
  isVariable?: boolean;
}

const TextField = ({
  id,
  label,
  labelDesc,
  placeholder,
  inputProps,
  isError,
  errorMessage,
  required,
  disabled,
  readOnly,
  autoFocus,
  maxLength,
  textLength,
  customClassName,
  customInputClassName,
  hint,
  hintId,
  size,
  defaultValue,
  hidden,
  isVariable,
}: Props) => {
  const errorMsg = T(errorMessage ?? '');

  return (
    <div className={`form-group flex-fill ${customClassName}`} id={id}>
      {label && <FormLabel label={label} labelDesc={labelDesc} isRequired={required} hint={hint} hintId={hintId} className='text-capitalize' />}
      {isVariable ? (
        <div className="d-flex align-items-center mb-3">
          <span className="pe-3">{`{{1}}`}</span>
          <input
            {...inputProps}
            className={`form-control ${size === 'sm' ? '' : 'p-3 '}`}
            type="text"
            placeholder={placeholder}
            maxLength={maxLength}
            disabled={disabled}
          />
        </div>
      ) : (
        <div className="input-group">
          <input
            {...inputProps}
            className={`form-control
                    ${size === 'sm' ? '' : 'p-3 '} 
                    ${textLength !== undefined ? 'rounded-start-12 ' : 'rounded-12'}
                    ${isError ? `is-invalid ${textLength !== undefined && 'rounded-end-0'}` : ''}
                    ${customInputClassName}
                `}
            type="text"
            placeholder={placeholder}
            disabled={disabled}
            readOnly={readOnly}
            autoFocus={autoFocus}
            maxLength={maxLength}
            defaultValue={defaultValue}
            hidden={hidden}
          />
          {textLength !== undefined && (
            <div className={`input-group-text rounded-end-12 ${size === 'sm' ? '' : 'p-3 '}`}>{`${textLength ?? 0}/${maxLength}`}</div>
          )}
          {errorMsg && <div className="invalid-feedback">{errorMsg}</div>}
        </div>
      )}
    </div>
  );
};

export default TextField;
